import MockAdapter from 'axios-mock-adapter/types'

export function mockOrderbook(mocker: MockAdapter) {
  mocker.onGet(RegExp('^/market/orderBook/')).reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          symbolId: 1,
          symbol: 'WETH_USDC',
          price: 1000,
          sellOrders: [
            ['1001', '10.8340'],
            ['1002', '6.9302'],
            ['1003', '4.109'],
            ['1004', '1.214'],
            // ['1005', '2.21'],
            // ['1006', '4.92'],
            // ['1007', '2.156'],
            // ['1008', '6.3640'],
            // ['1009', '10.0564'],
            // ['1010', '1.588'],
            // ['1011', '2.556'],
            // ['1012', '0.921'],
            // ['1013', '3.115'],
            // ['1014', '2.084'],
            // ['1015', '1.105'],
          ],
          buyOrders: [
            ['990', '2.453'],
            ['991', '8.384'],
            ['992', '3.245'],
            ['993', '9.0295'],
            ['994', '8.384'],
            ['995', '1.8342'],
            ['996', '4.0852'],
            ['997', '0.995'],
            ['998', '10.043'],
            ['999', '3.225'],
            ['1000', '6.552'],
            ['1001', '3.9301'],
            ['1002', '4.0245'],
            ['1003', '6.334'],
            ['1004', '9.802'],
            ['1005', '1.001'],
          ],
          sequenceId: 10000,
          direction: 0,
          timestamp: Date.now(),
        },
      },
    ]
  })
}
